import React, { useEffect, useRef } from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onClose }) => {
  const logoUrl = "/CurioLogo.png"; 
  const overlayRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === overlayRef.current) {
      onClose();
    }
  };

  return (
    <div 
      ref={overlayRef}
      className="welcome-screen-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="welcome-message"
      onMouseDown={handleOverlayClick}
    >
      <div className="welcome-screen-content">
        <button 
          onClick={onClose} 
          className="close-button"
          aria-label="Close welcome screen"
        >
          ×
        </button>
        
        <img 
          src={logoUrl} 
          alt="CURIO App Logo - an owl with glasses looking at a globe" 
          className="logo"
        />
        
        <p id="welcome-message" className="welcome-message">
          Hi, I'm Curio! I'm here to help you effortlessly discover interesting context about the cities & sights you explore.
        </p>
        
        <button 
          onClick={onClose} 
          className="get-started-button"
        >
          Get Started
        </button>
      </div>
    </div>
  );
};

export default WelcomeScreen;